"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadRequestSchema = void 0;
const zod_1 = require("zod");
exports.FileUploadRequestSchema = zod_1.z.object({
    body: zod_1.z.any(),
    file: zod_1.z.object({
        fieldname: zod_1.z.literal('file'),
        originalname: zod_1.z.string(),
        encoding: zod_1.z.string(),
        mimetype: zod_1.z.string(),
        size: zod_1.z.number(),
        buffer: zod_1.z.any()
    })
});
